/**
 * Copyright (c) 2019 Vendor Badge, LLC All Rights Reserved.
 *
 *  Portal - Company View - TabPanel
 */
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

// Design System
import Box from '@material-ui/core/Box';
import ContentHeader from 'components/LocationProfile/ContentHeader';

function TabPanel(props) {
  const { children, value, index, title } = props;
  const classes = styles();

  return (
    <div className={classes.root} hidden={value !== index}>
      <ContentHeader value={value} index={index} title={title} />
      <Box p={3} className={classes.content}>
        {children}
      </Box>
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const styles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  content: {
    flexGrow: 1,
    paddingTop: '10px',
    [theme.breakpoints.down('xs')]: {
      paddingRight: '0px',
      paddingLeft: '0px',
    },
  },
}));

export default TabPanel;
